<template>
  <div>
    <div class="vx-row justify-center">
      <div class="mb-8">
        <label class="vs-input--label pl-1">Дата:</label>
        <elsa-v-datepicker v-model="selectedDate" />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full flex justify-center">
        <vs-button
          id="toggle-shown-button"
          type="border"
          class="vs-con-loading__container"
          :disabled="loading || !selectedDate"
          @click="onSubmit"
        >
          {{ isDisabled ? 'Включить' : 'Отключить' }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import modalContext    from "@/mixins/modalContext";

export default {
  name:   "DeviceToggleStatePopup",
  mixins: [notifyHttpError, modalContext],
  props:  ['device'],
  data() {
    return {
      loading:      false,
      selectedDate: null,
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    isDisabled() {
      return this.device.actual_state === 7;
    },

  },
  watch:    {},
  methods:  {
    onSubmit() {
      const action = this.isDisabled
        ? `support/device/${this.device.id}/activate`
        : `support/device/${this.device.id}/disable`;

      this.loading = true;
      this.$http.put(action, { active_since: this.selectedDate.toISOString() }, { params: { buildings_id: this.selectedHouseId } }).then(
        () => this.modalResolve(),
        ( e ) => {
          this.loading = false;
          this.notifyHttpError(e);
        },
      );
    },
  },
};
</script>

<style lang="scss">

</style>
